import Button from '@ui/Button';
import React, { FC } from 'react';
import { I18n } from 'react-redux-i18n';
import styles from './styles.module.scss';
import { userApi } from '@api/index';
import { toast } from 'react-toastify';

interface Props {
  lessonId: string;
}
const ConnectToLesson: FC<Props> = ({ lessonId }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <span className={styles.stepTitle}>
          {I18n.t('onboarding.connect.title')}
        </span>
        <p className={styles.stepHint}>{I18n.t('onboarding.connect.info')}</p>
      </div>
      <div className={styles.right}>
        <a
          target="_blank"
          href={`https://meet.progkids.com/room/${lessonId}`}
          rel="noopener noreferrer"
        >
          <Button color="green" className={styles.action}>
            {I18n.t('onboarding.connect.title')} →
          </Button>
        </a>

        <div className={styles.downloadInfo} />
        <Button
          className={styles.action}
          color="white"
          onClick={() => {
            userApi.needContact().then(() => {
              toast.success(I18n.t('onboarding.connect.done'));
            });
          }}
        >
          {I18n.t('onboarding.connect.contact')}
        </Button>
      </div>
    </div>
  );
};

export default ConnectToLesson;
